import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Sub.module.css";
import { MdOutlineAddLocationAlt, MdOutlineArrowRight } from "react-icons/md";
import UsoCep from "../usoCep/usoCep";
import DigiteCep from "../DigiteCep/DigiteCep";
import { categories } from "../../utils/category";
import { brands } from "../../utils/brand";
import { useTranslation } from "react-i18next";
import { useCep } from "../../context/CepContext";

interface SubHeaderProps {
  isSmallScreen?: boolean;
}

export default function SubHeader({ isSmallScreen = false }: SubHeaderProps) {
  const [categoryIsDown, setCategoryIsDown] = useState(false);
  const [brandIsDown, setBrandIsDown] = useState(false);
  const [isCepVisible, setIsCepVisible] = useState(false);
  const [isDigiteCepVisible, setIsDigiteCepVisible] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [anotherCep, setAnotherCep] = useState<boolean>(false);
  const { cep, changeCep } = useCep()
  const navigate = useNavigate();
  const { t } = useTranslation(undefined, { keyPrefix: 'subHeader' })

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
    const cep = localStorage.getItem("cep");
    if (cep) {
      changeCep(cep);
    } else {
      changeCep('');
    }
  }, []);

  function handleClose() {
    setIsCepVisible(false);
    setIsDigiteCepVisible(false);
    setAnotherCep(false);
  }

  const handleClickOnCep = () => {
    const clientId = localStorage.getItem('clientId')
    if (isLoggedIn && clientId) {
      setIsCepVisible(true);
      return
    } else if(isLoggedIn) {
      setAnotherCep(true)
    }
    setIsDigiteCepVisible(true);
  };

  const handleCategoryClick = (category: string) => {
    // Formata a categoria para a URL
    navigate(`/search/1?categories=${category}`);
    setCategoryIsDown(!categoryIsDown);
  };

  const handleBrandClick = (brand: string) => {
    // Formata a categoria para a URL
    navigate(`/search/1?brands=${brand}`);
    setBrandIsDown(!brandIsDown);
  };


  return (
    <>
      <div className={styles.containerSubHeader} style={{ display: isSmallScreen ? "none" : "flex" }}>
        <div className={styles.containerOptions}>
          {/* Categorias */}
          <div>
            <div
              className={styles.wrapperOptions}
              onClick={() => {
                setBrandIsDown(false)
                setCategoryIsDown(!categoryIsDown)
              }}
            >
              <MdOutlineArrowRight
                size={30}
                color={"#FFF"}
                className={categoryIsDown ? `${styles.arrow} ${styles.down}` : `${styles.arrow}`}
              />
              <p>{t("categories")}</p>
            </div>
            {categoryIsDown && (
              <div className={styles.dropdown}>
                <ul>
                  {categories.map((category, index) => (
                    <li key={index} onClick={() => handleCategoryClick(category.name)}>
                      {category.name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* Ofertas */}
          <div>
            <div
              className={styles.wrapperOptions}
              onClick={() => {
                setCategoryIsDown(false)
                setBrandIsDown(!brandIsDown)
              }}
            >
              <MdOutlineArrowRight 
                size={30} 
                color={"#FFF"}
                className={brandIsDown ? `${styles.arrow} ${styles.down}` : `${styles.arrow}`}  
              />
              <p>{t("brands")}</p>
            </div>
            {brandIsDown && (
              <div className={styles.dropdown}>
                <ul>
                  {brands.map((brand, index) => brand.name !== 'Outro' ? (
                    <li key={index} onClick={() => handleBrandClick(brand.name)}>
                      {brand.name}
                    </li>
                  ) : undefined)}
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* Componente CEP */}
        <div className={styles.containerLocation} onClick={handleClickOnCep}>
          <MdOutlineAddLocationAlt size={28} color={"#FFFFFF"} />
          <p>{cep ? cep : t("zipcode")}</p>
        </div>
      </div>

      <button className={styles.SubHeaderCEP} onClick={handleClickOnCep} style={{ display: isSmallScreen ? "" : "none" }}>
        <MdOutlineAddLocationAlt size={28} color={"#fff"} />
      </button>

      {/* Component Usage */}
      {isCepVisible && isLoggedIn && <UsoCep setCep={changeCep} onClose={handleClose} onCancel={() => { setAnotherCep(true); setIsCepVisible(false); setIsDigiteCepVisible(true) }} />}
      {isDigiteCepVisible && !isLoggedIn && <DigiteCep cep={cep} setCep={changeCep} onClose={handleClose} />}
      {isDigiteCepVisible && anotherCep && <DigiteCep cep={cep} setCep={changeCep} onClose={handleClose} />}
    </>
  );
}
